"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadNetlistSchematicModel = exports.META_KICAD_UNIT = exports.MetadataKicadIsRoot = exports.KicadDocLibPreamble = exports.KicadSymbolLibTablePreamble = exports.KicadFootprintLibTablePreamble = exports.EESchemaLibPreamble = exports.EESchemaSchPreamble = exports.KicadSchPreamble = exports.KicadPcbPreamble = void 0;
exports.KicadPcbPreamble = '(kicad_pcb';
exports.KicadSchPreamble = '(kicad_sch';
exports.EESchemaSchPreamble = 'EESchema Schematic';
exports.EESchemaLibPreamble = 'EESchema-LIBRARY';
exports.KicadFootprintLibTablePreamble = '(fp_lib_table';
exports.KicadSymbolLibTablePreamble = '(sym_lib_table';
exports.KicadDocLibPreamble = 'EESchema-DOCLIB';
exports.MetadataKicadIsRoot = 'kicadisroot';
exports.META_KICAD_UNIT = 'kicad.unit';
exports.KicadNetlistSchematicModel = 'netlist-schematic-model';
//# sourceMappingURL=constants.js.map